'use strict';

var _base = require('./base.js');

var _base2 = _interopRequireDefault(_base);

var _cache = require('./cache.js');

var _cache2 = _interopRequireDefault(_cache);

var _date = require('./date.js');

var _date2 = _interopRequireDefault(_date);

var _function = require('./function.js');

var _function2 = _interopRequireDefault(_function);

var _money = require('./money.js');

var _money2 = _interopRequireDefault(_money);

var _image = require('./image.js');

var _image2 = _interopRequireDefault(_image);

var _math = require('./math.js');

var _math2 = _interopRequireDefault(_math);

var _regexp = require('./regexp.js');

var _regexp2 = _interopRequireDefault(_regexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  @desc 入口js，将其他的方法整合到一起
 *  @create 2016-10-14
 *  @modify 2016-10-14
 *  @author wangkuan
 */
module.exports = _function2.default.extend(_base2.default, _cache2.default, _date2.default, _function2.default, _money2.default, _image2.default, _math2.default, _regexp2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/index.js
// module id = Uy6l
// module chunks = 11